// Service for employee contract edit operations
// GET /v{version}/employees/{employeeId}/contracts/{contractId}
// PUT /v{version}/employees/{employeeId}/contracts/{employeeContractId}
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type {
  LC_GetEmployeeContractByIdOut,
  LC_UpdateEmployeeContractIn,
  LC_UpdateEmployeeContractOut,
} from '../types/employeeContractEdit.types';


/**
 * Service for employee contract edit operations
 */
export class EmployeeContractEditService {
  /**
   * GET employee contract by ID
   * Endpoint: GET /v{version}/employees/{employeeId}/contracts/{contractId}
   * 
   * @param employeeId - Employee ID
   * @param contractId - Employee contract ID
   * @returns ApiResponse with contract details
   */
  async get(
    employeeId: number,
    contractId: number,
  ): Promise<ApiResponse<LC_GetEmployeeContractByIdOut>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_CONTRACT.GET(employeeId, contractId);
    return apiClient.get<LC_GetEmployeeContractByIdOut>(endpoint);
  }

  /**
   * PUT update employee contract
   * Endpoint: PUT /v{version}/employees/{employeeId}/contracts/{employeeContractId}
   * 
   * @param employeeId - Employee ID
   * @param employeeContractId - Employee contract ID
   * @param data - LC_UpdateEmployeeContractIn
   * @returns ApiResponse with update result
   */
  async update(
    employeeId: number,
    employeeContractId: number,
    data: LC_UpdateEmployeeContractIn,
  ): Promise<ApiResponse<LC_UpdateEmployeeContractOut>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_CONTRACT.UPDATE(employeeId, employeeContractId);
    return apiClient.put<LC_UpdateEmployeeContractOut>(endpoint, data);
  }
}

export const employeeContractEditService = new EmployeeContractEditService();
